<picture>
  <!-- srcset is bound rather than *ngIf'd so the <source> is always in the DOM
       before the browser resolves the image, regardless of view creation order.
       A <source> with no srcset is skipped by the selection algorithm. -->
  <ng-container *ngFor="let source of sources">
    <source type="image/webp" [attr.media]="source.media" [attr.srcset]="source.webpSrc || null">
    <source [attr.media]="source.media" [attr.srcset]="source.src || null">
  </ng-container>
  <source type="image/webp" [attr.srcset]="webpSrc || null">
  <img [attr.src]="src || null" [alt]="alt" [attr.width]="width" [attr.height]="height" [attr.loading]="eager ? 'eager' : 'lazy'" decoding="async" [style.object-position]="backgroundPosition">
</picture>
